"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.PriceCurrent = exports.PricePrevious = exports.PriceWrap = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _rebass = require("rebass");

var _Typography = require("../../../Typography");

var PriceWrap = (0, _styled.default)(_rebass.Box)({
  textAlign: 'right'
});
exports.PriceWrap = PriceWrap;
var PricePrevious = (0, _styled.default)(_Typography.Body)(function (_ref) {
  var cards = _ref.theme.cards;
  return {
    textDecoration: 'line-through',
    display: 'inline-block',
    marginRight: '0',
    fontWeight: cards.priceTextWeight
  };
});
exports.PricePrevious = PricePrevious;
var PriceCurrent = (0, _styled.default)(_Typography.Body)(function (_ref2) {
  var _ref2$theme = _ref2.theme,
      space = _ref2$theme.space,
      cards = _ref2$theme.cards,
      price = _ref2.price;
  return {
    display: 'inline-block',
    marginLeft: price.previous ? space.base : '0',
    marginRight: '0',
    fontWeight: cards.priceTextWeight
  };
});
exports.PriceCurrent = PriceCurrent;